export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&',
  },
  {
    name: 'switchWrapper',
    label: 'Switch Wrapper',
    selector: '& > .switch',
  },
  {
    name: 'box',
    label: 'Box',
    selector: '& > .box',
  },
];
